import LandingScreen from './screens/landing/LandingScreen'

import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import routes from './config/routes'
import { CoworkingQueryClient } from './modules/CoworkingQueryClient'
import { BookAssistantProvider } from './providers/bookAssistant'
import { CardTransitionProvider } from './providers/cardTransition/cardTransition'
import { ProfileAssistantProvider } from './providers/profileAssistant'
import { AppRootScreen } from './screens/app/root/AppRootScreen'
import store from './store'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://2441f35e9af24b968a6e010be31dc09f@o1420387.ingest.sentry.io/4503958558146560',
    integrations: [Sentry.browserTracingIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 5.0,
    release: '0.1.0',
  })
}

const App = () => {
  return (
    <QueryClientProvider client={CoworkingQueryClient}>
      <Provider store={store}>
        <BookAssistantProvider>
          <ProfileAssistantProvider>
            <CardTransitionProvider>
              <BrowserRouter>
                <Routes>
                  <Route path={routes.landing} element={<LandingScreen />} />
                  <Route path={`${routes.baseApp}/*`} element={<AppRootScreen />} />
                </Routes>
              </BrowserRouter>
            </CardTransitionProvider>
          </ProfileAssistantProvider>
        </BookAssistantProvider>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App
